import { render, staticRenderFns } from "./UIFormTime.vue?vue&type=template&id=ddabfa90&"
import script from "./UIFormTime.vue?vue&type=script&lang=js&"
export * from "./UIFormTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports